import { gql } from '@grandvisionhq/graphql';

const recoverInactiveCartFailure = gql`
  fragment RecoverInactiveCartFailureFragment on RecreateOrderedCheckoutFailure {
    code
    message
  }
`;

export { recoverInactiveCartFailure };
//# sourceMappingURL=recover-inactive-cart-failure.js.map
